"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Removed export for style export change.
var Button = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    (0, _classCallCheck2.default)(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getFullWidth", function () {
      // Populating fullWidth in this manner since MuiIconButton and MuiFab do not support the fullWidth prop
      var _this$props = _this.props,
          type = _this$props.type,
          fullWidth = _this$props.fullWidth;

      if (type !== "icon" && type !== "fab") {
        return {
          fullWidth: fullWidth
        };
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          children = _this$props2.children,
          classes = _this$props2.classes,
          className = _this$props2.className,
          component = _this$props2.component,
          color = _this$props2.color,
          disabled = _this$props2.disabled,
          href = _this$props2.href,
          onClick = _this$props2.onClick,
          size = _this$props2.size,
          type = _this$props2.type,
          variant = _this$props2.variant,
          openInNewWindow = _this$props2.openInNewWindow,
          startIcon = _this$props2.startIcon,
          endIcon = _this$props2.endIcon,
          title = _this$props2.title,
          tooltipProps = _this$props2.tooltipProps,
          stopPropagation = _this$props2.stopPropagation,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props2, ["id", "children", "classes", "className", "component", "color", "disabled", "href", "onClick", "size", "type", "variant", "openInNewWindow", "startIcon", "endIcon", "title", "tooltipProps", "stopPropagation"]);
      var ButtonComponent, buttonTypeClass, renderedVariant;
      renderedVariant = variant;

      if (type === "icon") {
        ButtonComponent = _IconButton.default;
        buttonTypeClass = (0, _classnames.default)(classes.iconButton, "prmbl-iconBtn");
      } else if (type === "fab") {
        ButtonComponent = _Fab.default;
        buttonTypeClass = classes.fab;
        renderedVariant = undefined;
      } else {
        ButtonComponent = _Button.default;
        buttonTypeClass = classes.button;
      }

      var touchRippleProps = {
        classes: {
          root: "prmbl-touchRipple"
        }
      };
      var renderedOnClick = stopPropagation ? function (event) {
        event.stopPropagation();
        if (onClick) onClick(event);
      } : onClick;

      var renderedButton = /*#__PURE__*/_react.default.createElement(ButtonComponent, (0, _extends2.default)({
        id: id,
        color: color,
        component: component,
        className: (0, _classnames.default)("prmbl-button", (0, _defineProperty2.default)({}, "prmbl-button--".concat(color), color), (0, _defineProperty2.default)({}, classes.sizeSmall, size === "small"), (0, _defineProperty2.default)({}, classes.sizeLarge, size === "large"), (0, _defineProperty2.default)({}, classes.iconButtonSizeSmall, size === "small" && type === "icon"), (0, _defineProperty2.default)({}, classes.iconButtonSizeLarge, size === "large" && type === "icon"), className, buttonTypeClass),
        disabled: disabled
      }, _this.getFullWidth(), {
        target: openInNewWindow ? "_blank" : undefined,
        href: href,
        rel: "noopener noreferrer",
        onClick: renderedOnClick,
        size: size,
        variant: renderedVariant,
        TouchRippleProps: touchRippleProps
      }, otherProps, {
        "aria-label": otherProps["aria-label"] ? otherProps["aria-label"] : title ? title : undefined
      }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, startIcon && /*#__PURE__*/_react.default.createElement("span", {
        className: classes.startIcon
      }, startIcon), children, endIcon && /*#__PURE__*/_react.default.createElement("span", {
        className: classes.endIcon
      }, endIcon)));

      return title ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({
        title: title,
        placement: "bottom"
      }, tooltipProps), renderedButton) : renderedButton;
    });
    return _this;
  }

  return Button;
}(_react.Component);

(0, _defineProperty2.default)(Button, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   *
   * Utilized By:
   * LiveEdit,
   * Expansion Panel: Added so that ExpansionPanel could apply classes to the actions.
   *
   * Preamble => Page
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those those theme colors
   * that make sense for this component
   */
  color: _propTypes.default.oneOf(["default", "primary", "secondary", "inherit"]),

  /**
   * You can use this prop with react-router. See https://material-ui.com/guides/composition/#button
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The URL to link to when the button is clicked. If desired, an `a` element will
   * be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * Callback to execute when the button is pressed
   */
  onClick: _propTypes.default.any,

  /**
   * The size of the button. `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(["small", "medium", "large"]),

  /**
   * Additional styles to render
   */
  style: _propTypes.default.object,

  /**
   * The type of button to render
   */
  type: _propTypes.default.oneOf(["default", "icon", "fab"]),

  /**
   * The style of button.
   */
  variant: _propTypes.default.oneOf(["contained", "outlined", "text"]),

  /**
   * Set true to open the href in a new window.
   */
  openInNewWindow: _propTypes.default.bool,

  /**
   * Icon placed to the left of the text
   */
  startIcon: _propTypes.default.node,

  /**
   * Icon placed to the right of the text
   */
  endIcon: _propTypes.default.node,

  /**
   * The tooltip to display for the button
   */
  title: _propTypes.default.node,

  /**
   * An accessibility label to display for the button. Defaults to the title prop. If title prop omitted, and the icon is a button variant, this is required for accessibility.
   */
  "aria-label": _propTypes.default.string,

  /**
   * Props to spread to the Tooltip component if rendered
   */
  tooltipProps: _propTypes.default.object,

  /**
   * The tab index of the button. Should be 0 if the button is selectable, -1 if the button is not selectable.
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * If true, we will stop propagation of event execution for onClick.
   */
  stopPropagation: _propTypes.default.bool,

  /**
   * HTML role
   */
  role: _propTypes.default.string
});
(0, _defineProperty2.default)(Button, "defaultProps", {
  variant: "contained",
  type: "default",
  tooltipProps: {
    placement: "bottom"
  }
});
var buttonWithStyles = (0, _styles2.withStyles)(_styles.styles)(Button);
exports.Button = buttonWithStyles;
buttonWithStyles.defaultProps = {
  variant: "contained",
  type: "default",
  className: ""
};
// Export styled version with name "Button"
var _default = buttonWithStyles; // Keep existing default export working

exports.default = _default;